<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('detailOrdreTravailTech.caracterique.bonStock.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t(constantes.DATE_DE_BON_SORTIE)"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              <router-link-blank
                :to="{
                  name: constantes.DETAILS_BON_SORTIE_ROUTE,
                  params: { id: ot.otStock.bonStockId,
                }}"
                class="lien"
                :message="func.formatDate(ot.dateSouhaitee) ">
              </router-link-blank>
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('stock.informations.lieuDeStockage')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              <router-link-blank
                :to="{
                  name: 'c.bodac.clients/contacts-client',
                  params: { id: ot.otStock.lieuDeStockage.id,
                }}"
                class="lien"
                v-if="ot.otStock.lieuDeStockage.id"
                :message="ot.otStock.lieuDeStockage.nomCommercial ">
              </router-link-blank>
            </span>
          </b-field>
        </div>
        <div class="column is-3" v-if="ot.otStock.produit">
          <b-field :label="$t('stock.tab.produit')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ot.otStock.produit.libelle }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('stock.tab.quantite')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ ot.otStock.quantite  }}
            </span>
          </b-field>
        </div>
    </div>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  DETAILS_BON_SORTIE_ROUTE, DATE_DE_BON_SORTIE,
} from '@/configuration/bonStock/menuStockConf';
import formatDate from '@/services/general/formatDate';

export default {
  props: {
    ot: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        DETAILS_BON_SORTIE_ROUTE,
        DATE_DE_BON_SORTIE,
      },
      func: {
        formatDate,
      },
    };
  },
  components: {
    routerLinkBlank,
  },
};

</script>
